import { render, staticRenderFns } from "./SalaryManager.vue?vue&type=template&id=3585db96&scoped=true"
import script from "./SalaryManager.vue?vue&type=script&lang=js"
export * from "./SalaryManager.vue?vue&type=script&lang=js"
import style0 from "./SalaryManager.vue?vue&type=style&index=0&id=3585db96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585db96",
  null
  
)

export default component.exports